<template>
  <div class="fill-height">
    <line-chart
      v-if="viewMode === 'chart'"
      class="fill-height"
      :raw-data="players"
      :chart-value-keys="chartValueKeys"
      x-value="last_name"
      :y-value-prefix="'latest_stats.'"
      :yaxis="yAxisConfig"
      :xaxis="xAxisConfig"
      :fill="fillConfig"
      :colors="['#8F6BE5', '#EB4646', '#00BFFF']"
    >
      <template v-slot:header>
        <v-card-title class="pa-6 d-flex justify-space-between">
          <div class="subtitle-2 grey--text text--grey-100">
            {{ $t('card_title.team_sleep_quality') }}
          </div>
          <v-btn
            v-if="removable"
            icon
            style="pointer-events: auto"
            @click="$emit('remove')"
          >
            <v-icon small>
              fal fa-times
            </v-icon>
          </v-btn>
          <visual-list-toggle
            v-else
            :value.sync="viewMode"
          />
        </v-card-title>
      </template>
    </line-chart>

    <v-card
      v-else-if="viewMode === 'table'"
      class="fill-height rounded-lg"
    >
      <v-card-title class="pa-6 d-flex justify-space-between">
        <div class="subtitle-2 grey--text text--grey-100">
          {{ $t('card_title.team_sleep_quality') }}
        </div>
        <div class="d-flex align-center">
          <visual-list-toggle
            v-if="!removable"
            :value.sync="viewMode"
          />
        </div>
      </v-card-title>

      <v-data-table
        :headers="tableHeaders"
        :items="players"
        hide-default-footer
        disable-pagination
        :items-per-page="-1"
        fixed-header
        dense
        :height="350"
      >
        <template v-slot:item.last_name="{ item }">
          {{ item.last_name }}, {{ item.first_name }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'
import VisualListToggle from '@/components/buttons/VisualListToggle.vue'

export default {
  name: 'SleepQualitySleepDurationChart',
  components: { LineChart, VisualListToggle },
  props: {
    players: {
      type: Array,
      required: true,
      default: () => []
    },
    removable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    viewMode: 'chart'
  }),
  computed: {
    chartValueKeys() {
      return [
        {
          key: 'SLQ',
          label: this.$t('variables.SLQ.long'),
          type: 'bar'
        },
        {
          key: 'FAT',
          label: this.$t('variables.FAT.long'),
          type: 'bar'
        },
        {
          key: 'SLD',
          label: this.$t('variables.SLD.long'),
          type: 'area'
        }
      ]
    },
    yAxisConfig() {
      return [
        {
          min: 0,
          max: 5,
          title: { text: this.$t('variables.SLQ.long') },
          type: 'linear'
        },
        {
          min: 0,
          max: 5,
          title: { text: this.$t('variables.FAT.long') },
          type: 'linear'
        },
        {
          min: 0,
          max: Math.max(12, ...this.players.map(p => p.latest_stats?.SLD || 0)),
          title: { text: this.$t('variables.SLD.long') },
          type: 'linear',
          opposite: true
        }
      ]
    },
    xAxisConfig() {
      return {
        labels: {
          rotate: -45
        },
        categories: this.players.map(p => p.first_name[0] + '. ' + p.last_name),
        tickPlacement: 'between'
      }
    },
    fillConfig() {
      return {
        type: ['solid', 'solid', 'gradient'],
        opacity: [0.7, 0.7, 1],
        gradient: {
          inverseColors: false,
          shade: 'light',
          type: 'vertical',
          opacityFrom: 0.55,
          opacityTo: 0.25
        }
      }
    },
    tableHeaders() {
      return [
        {
          text: this.$t('table_headers.name'),
          value: 'last_name',
          sortable: true,
          width: '20%'
        },
        {
          text: this.$t('variables.SLQ.long'),
          value: 'latest_stats.SLQ',
          sortable: true,
          align: 'center'
        },
        {
          text: this.$t('variables.FAT.long'),
          value: 'latest_stats.FAT',
          sortable: true,
          align: 'center'
        },
        {
          text: this.$t('variables.SLD.long'),
          value: 'latest_stats.SLD',
          sortable: true,
          align: 'center'
        }
      ]
    }
  }
}
</script>
